import React from "react";
import { Form } from "antd";
import TeamsSelector from "./TeamsSelector";

const TeamSelectField = ({
  name,
  allTeams,
  isEdit,
  onTeamChange,
  selectedTeamIds = [],
}) => {
  const form = Form.useFormInstance();
  const selected = Form.useWatch(["teams", name, "team"], form);

  const filteredTeams = allTeams.map((team) => ({
    ...team,
    label: team.name,
    value: team.id,
    disabled: selectedTeamIds.includes(team.id),
  }));

  return (
    <TeamsSelector
      teamsOptions={filteredTeams}
      selectedTeams={selected ? [selected] : []}
      onChange={(val) => {
        form.setFieldValue(["teams", name, "team"], val[0]);
        onTeamChange(val);
      }}
      singleSelect={true}
      formState={isEdit === true ? "edit" : "add"}
    />
  );
};

export default TeamSelectField;
